import { useId } from 'site/sdk/useId.ts'

export default function Checkbox() {
    const id = useId()

    return (
        <div class='_checkbox'>
            <input type='checkbox' name='accept' id={id} />
            <label for={id} />
        </div>
    )
}
